import request from '@/utils/request'

// 查询学分规则 列表
export function listRules(query) {
  return request({
    url: '/system/rules/list',
    method: 'get',
    params: query
  })
}

// 查询学分规则 详细
export function getRules(ruleCode) {
  return request({
    url: '/system/rules/' + ruleCode,
    method: 'get'
  })
}

// 新增学分规则 
export function addRules(data) {
  return request({
    url: '/system/rules',
    method: 'post',
    data: data
  })
}

// 修改学分规则 
export function updateRules(data) {
  return request({
    url: '/system/rules',
    method: 'put',
    data: data
  })
}

// 删除学分规则 
export function delRules(ruleCode) {
  return request({
    url: '/system/rules/' + ruleCode,
    method: 'delete'
  })
}
